
import { RootStore } from ".";
import { observable, action, runInAction } from "mobx";
import { fetchWrapper } from "../common/Fetch";
import { SuccessableResult, KeyValue } from "../common/BaseClasses";


export interface CdekTerminal {
    name: string;
    code: string;
    location: CdekTerminalLocation;
}

export interface CdekTerminalLocation {
    address: string;
    addressFull: string;
}

export interface CdekCalculateResult {
    errors: CdekCalculateErrorInfo[];
    price: number;
    deliveryPeriodMin: number;
    deliveryPeriodMax: number;
}
interface CdekCalculateErrorInfo {
    code: number;
    text: string;
}



export class CdekStore {

    _rootStore: RootStore;

    @observable regions?: KeyValue<string, string>[] = undefined;

    constructor(rootStore: RootStore) {
        this._rootStore = rootStore;
    }

    @action
    loadRegions(successCallback: (regions: KeyValue<string, string>[]) => void) {

        if (this.regions != undefined) {
            successCallback(this.regions);
            return;
        }

        fetchWrapper(`api/delivery/cdekregions/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }, this._rootStore.commonStore)
            .then(res => res.json() as Promise<KeyValue<string, string>[]>)
            .then(result => {
                runInAction("fetch complete loadRegions", () => {
                    this.regions = result;
                    successCallback(this.regions);
                });
            })
            .catch(res => {
                console.log(res);
            });
    }

    @action
    loadCities(regionCode: string, successCallback: (cities: KeyValue<number, string>[]) => void) {

        fetchWrapper(`api/delivery/cdekcities/${regionCode}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }, this._rootStore.commonStore)
            .then(res => res.json() as Promise<KeyValue<number, string>[]>)
            .then(result => {
                runInAction("fetch complete loadCities", () => {
                    successCallback(result);
                });
            })
            .catch(res => {
                console.log(res);
            });
    }
    @action
    loadTerminals(cityCode: number, successCallback: (terminals: CdekTerminal[]) => void) {

        fetchWrapper(`api/delivery/cdekterminals/${cityCode}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }, this._rootStore.commonStore)
            .then(res => res.json() as Promise<CdekTerminal[]>)
            .then(result => {
                runInAction("fetch complete loadTerminals", () => {
                    successCallback(result);
                });
            })
            .catch(res => {
                console.log(res);
            });
    }
    @action
    calculate(cityCode: number, positionsCount: number, toAddress: boolean, successCallback: (calculatedPrice: number) => void) {

        fetchWrapper(`api/delivery/cdekcalculate/${cityCode}/${positionsCount}/${toAddress}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }, this._rootStore.commonStore)
            .then(res => res.json() as Promise<SuccessableResult<CdekCalculateResult>>)
            .then(result => {
                runInAction("fetch complete calculate", () => {
                    if (result.isSuccess)
                        successCallback(result.data.price);
                    else {
                        if (result.data.errors != undefined) {
                            result.data.errors.forEach((item) => {
                                this._rootStore.commonStore.notifyError(item.text);
                            })
                        }
                        else
                            this._rootStore.commonStore.notifyError(result.errorMessage);
                    }
                });
            })
            .catch(res => {
                console.log(res);
            });
    }
}